module.exports = __webpack_public_path__ + "img/317.379a3d11.png";